import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: string | Date): string {
    const createdDate = new Date(value);
    const currentDate = new Date();

    const diffInMs = currentDate.getTime() - createdDate.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const ago = this.translateService.instant('common.ago');
    if (diffInMinutes < 1) {
      return this.translateService.instant('common.just_now');
    } else if (diffInMinutes < 60) {
      const minutes = this.translateService.instant(
        'data_requests.details.process.history.minutes',
      );
      const minute = this.translateService.instant(
        'data_requests.details.process.history.minute',
      );
      return `${diffInMinutes} ${diffInMinutes > 1 ? minutes : minute} ${ago}`;
    } else if (diffInHours < 24) {
      const hour = this.translateService.instant(
        'data_requests.details.process.history.hour',
      );
      const hours = this.translateService.instant(
        'data_requests.details.process.history.hours',
      );
      return `${diffInHours} ${diffInHours > 1 ? hours : hour} ${ago}`;
    } else {
      const days = this.translateService.instant(
        'data_requests.details.process.history.days',
      );
      const day = this.translateService.instant(
        'data_requests.details.process.history.day',
      );
      return `${diffInDays} ${diffInDays > 1 ? days : day} ${ago}`;
    }
  }
}
